// Size Chart
 function triggerKsChartClick() {
    const chart = document.querySelector('.ks-chart-modal-link');
    if (chart) {
      chart.click();
    } else {
      console.warn('Element with class .ks-chart not found.');
    }
  }
  // mbl add to cart
  function toggleSizeChart(button) {
  const isMobile = window.innerWidth <= 768;
  const productCard = button.closest('.product-card');
  const sizeChart = button.closest('.size-chart-container');
  const sizeContainer = productCard.querySelector('.product-card-sizes--container');
  const beaconButton = document.querySelector('.BeaconFabButtonFrame');
  let hidbar = document.querySelector('.needsclick');
  if (!sizeContainer) return;

  const transformValue = window.getComputedStyle(sizeContainer).transform;
  const isHidden = transformValue.includes('matrix') && transformValue !== 'none' && transformValue !== 'matrix(1, 0, 0, 1, 0, 0)';

  if (isHidden) {
    // ✅ CLOSE ALL OTHER OPENED CHARTS ON MOBILE
    if (isMobile) {
      document.querySelectorAll('.product-card').forEach(card => {
        const otherSizeContainer = card.querySelector('.product-card-sizes--container');
        const otherSizeChart = card.querySelector('.size-chart-container');
        const otherButton = card.querySelector('.size-chart-container .btn-mb-hdn');

        const otherTransform = window.getComputedStyle(otherSizeContainer).transform;
        const isOtherOpen = otherTransform === 'none';

        if (card !== productCard && isOtherOpen) {
          // Close other open chart
          otherSizeContainer.style.transform = 'translateY(100%)';
          otherSizeContainer.style.zIndex = '0';
          card.style.zIndex = '5';

          if (otherSizeChart) {
            otherSizeChart.style.bottom = '4px';
            otherSizeChart.style.position = '';
          }

          // ✅ Reset icon to PLUS for closed charts
          if (otherButton) {
            otherButton.innerHTML = `
              <svg fill="#272727" height="24" viewBox="0 -960 960 960" width="24" xmlns="http://www.w3.org/2000/svg">
                <path d="m460-460h-220v-40h220v-220h40v220h220v40h-220v220h-40z"></path>
              </svg>
            `;
          }
        }
        
      });

      if (beaconButton) beaconButton.style.display = "none";
    }

    // --- SHOW CURRENT CHART ---
    sizeContainer.style.transform = "none";
    button.innerHTML = `
      <svg fill="#272727" height="24" viewBox="0 -960 960 960" width="20" xmlns="http://www.w3.org/2000/svg">
        <path d="m256-227.69-28.31-28.31 224-224-224-224 28.31-28.31 224 224 224-224 28.31 28.31-224 224 224 224-28.31 28.31-224-224z"></path>
      </svg>
    `;
    productCard.style.zIndex = "45";
    sizeChart.style.bottom = '90px';
    if (hidbar) hidbar.style.display = 'none';
    

    if (beaconButton) beaconButton.style.display = "none";
    if (isMobile) sizeChart.style.position = "fixed";
      if (isMobile) {
      // document.body.style.pointerEvents = "none";
    }

  } else {
    // --- HIDE CURRENT CHART ---
    sizeContainer.style.transform = "translateY(100%)";
    sizeContainer.style.zIndex = "0";
    productCard.style.zIndex = "5";
    button.innerHTML = `
              <svg fill="#272727" height="24" viewBox="0 -960 960 960" width="24" xmlns="http://www.w3.org/2000/svg">
                <path d="m460-460h-220v-40h220v-220h40v220h220v40h-220v220h-40z"></path>
              </svg>
            `;
    
    if (beaconButton) beaconButton.style.display = "none";
    if (hidbar) hidbar.style.display = '';

    if (isMobile) {
      sizeChart.style.bottom = '4px';
      sizeChart.style.position = "";
      document.body.style.pointerEvents = "";
    } else {
      sizeChart.style.bottom = '10px';
    }
  }
}

// Keep Klaviyo teaser above the sticky add-to-cart bar
(function () {
  function syncTeaser() {
    const bar = document.querySelector('.product-add-to-cart-sticky');
    const visible = !!bar && bar.classList.contains('sticky--visible');
    document.body.classList.toggle('has-sticky-atc', visible);

    if (visible) {
      // distance from the viewport bottom to the top of the bar
      const h = Math.max(0, window.innerHeight - bar.getBoundingClientRect().top);
      document.documentElement.style.setProperty('--sticky-atc-h', h + 'px');
    }
  }

  function init() {
    const bar = document.querySelector('.product-add-to-cart-sticky');
    if (!bar) return;

    syncTeaser();

    // bar appears/disappears on scroll (class change)
    new MutationObserver(syncTeaser)
      .observe(bar, { attributes: true, attributeFilter: ['class'] });

    // bar grows when the size panel opens (+ button)
    if ('ResizeObserver' in window) {
      new ResizeObserver(syncTeaser).observe(bar);
    }

    window.addEventListener('resize', syncTeaser);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// add to cart +
function hoverSizeChart(button) {
  const isMobile = window.innerWidth <= 768;
  const productCard = button.closest('.product-card');
  const sizeChart = button.closest('.size-chart-container');
  const sizeContainer = productCard.querySelector('.product-card-sizes--container');

  if (!sizeContainer) return;

  let isOverButton = false;
  let isOverChart = false;
  let hideTimeout;

  const showChart = () => {
    clearTimeout(hideTimeout);
    sizeContainer.style.transform = "none";
    sizeContainer.style.zIndex = "10";
    button.style.display = "none"; // hide button when chart is shown
  };

  const hideChart = () => {
    sizeContainer.style.transform = "translateY(100%)";
    sizeContainer.style.zIndex = "0";
    sizeChart.style.bottom = isMobile ? '4px' : '10px';
    button.style.display = "block"; // show button again
  };

  const tryHide = () => {
    clearTimeout(hideTimeout);
    hideTimeout = setTimeout(() => {
      if (!isOverButton && !isOverChart) {
        hideChart();
      }
    }, 300); // Delay in ms before hiding to prevent flickering
  };

  // Prevent duplicate listeners
  if (button.dataset.hoverInitialized === "true") return;
  button.dataset.hoverInitialized = "true";

  button.addEventListener('mouseenter', () => {
    isOverButton = true;
    showChart();
  });

  button.addEventListener('mouseleave', () => {
    isOverButton = false;
    tryHide();
  });

  sizeContainer.addEventListener('mouseenter', () => {
    isOverChart = true;
    showChart();
  });

  sizeContainer.addEventListener('mouseleave', () => {
    isOverChart = false;
    tryHide();
  });

  // Show immediately on first hover
  showChart();
}

// add to cart +

function hoverSizeChart(button) {
  const isMobile = window.innerWidth <= 768;
  const productCard = button.closest('.product-card');
  const sizeChart = button.closest('.size-chart-container');
  const sizeContainer = productCard.querySelector('.product-card-sizes--container');

  if (!sizeContainer) return;

  let isOverButton = false;
  let isOverChart = false;
  let hideTimeout;

  const showChart = () => {
    clearTimeout(hideTimeout);
    sizeContainer.style.transform = "none";
    sizeContainer.style.zIndex = "10";
    button.style.display = "none"; // hide button when chart is shown
  };

  const hideChart = () => {
    sizeContainer.style.transform = "translateY(100%)";
    sizeContainer.style.zIndex = "0";
    sizeChart.style.bottom = isMobile ? '4px' : '10px';
    button.style.display = "flex"; // show button again
  };

  const tryHide = () => {
    clearTimeout(hideTimeout);
    hideTimeout = setTimeout(() => {
      if (!isOverButton && !isOverChart) {
        hideChart();
      }
    }, 300); // Delay in ms before hiding to prevent flickering
  };

  // Prevent duplicate listeners
  if (button.dataset.hoverInitialized === "true") return;
  button.dataset.hoverInitialized = "true";

  button.addEventListener('mouseenter', () => {
    isOverButton = true;
    showChart();
  });

  button.addEventListener('mouseleave', () => {
    isOverButton = false;
    tryHide();
  });

  sizeContainer.addEventListener('mouseenter', () => {
    isOverChart = true;
    showChart();
  });

  sizeContainer.addEventListener('mouseleave', () => {
    isOverChart = false;
    tryHide();
  });

  // Show immediately on first hover
  showChart();
}

// Beacon

function adjustBeaconPosition() {
  const stickyBar = document.querySelector('.product-add-to-cart-sticky');
  const beaconButton = document.querySelector('.BeaconFabButtonFrame');

  if (stickyBar && beaconButton) {
    if (stickyBar.classList.contains('sticky--visible')) {
      beaconButton.style.display = 'none';
    } else {
      beaconButton.style.display = 'none';
    }
  }
}

function waitForElementsAndInit() {
  const checkInterval = setInterval(() => {
    const stickyBar = document.querySelector('.product-add-to-cart-sticky');
    const beaconButton = document.querySelector('.BeaconFabButtonFrame');

    if (stickyBar && beaconButton) {
      clearInterval(checkInterval);

      // Initial adjustment
      adjustBeaconPosition();

      // Observe class changes on stickyBar
      const observer = new MutationObserver(adjustBeaconPosition);
      observer.observe(stickyBar, { attributes: true, attributeFilter: ['class'] });

      // Optional: Also observe DOM changes in case beacon reloads dynamically
      const beaconParent = beaconButton.parentNode;
      if (beaconParent) {
        const beaconObserver = new MutationObserver(adjustBeaconPosition);
        beaconObserver.observe(beaconParent, { childList: true, subtree: true });
      }
    }
  }, 300); // Check every 300ms

  // Stop after 15 seconds to avoid running forever
  setTimeout(() => clearInterval(checkInterval), 15000);
}

document.addEventListener('DOMContentLoaded', waitForElementsAndInit);

 

// Script for sizes
function applySizeClass() {
    const csContainer = document.querySelector('.cs-main-prd-info');
    if (!csContainer) {
        console.log('.cs-main-prd-info not found');
        return;
    }

    const allGrids = document.querySelectorAll('div[class*="PwzrGrid-root"]');
    let sizeGrid = null;

    for (const grid of allGrids) {
        if (grid.getAttribute('data-option') === 'Size') {
            sizeGrid = grid;
            break;
        }
    }

    if (sizeGrid) {

        const children = sizeGrid.children;
        for (let i = 0; i < children.length; i++) {
            children[i].classList.add('cs-width-size');
        }
      
    } 
}

// Run on initial page load
document.addEventListener("DOMContentLoaded", function () {
    applySizeClass();

    // Monitor for DOM changes (for AJAX-loaded content)
    const observer = new MutationObserver(() => {
        applySizeClass();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});


// Btn Upt

document.addEventListener('DOMContentLoaded', function () {
  if (!document.querySelector('.cs-main-prd-info')) return;

  const maxWaitTime = 5000; // 5 seconds
  const intervalTime = 100; // check every 100ms
  let elapsed = 0;

  const interval = setInterval(() => {
    const priceDiv = document.querySelector('.lbtu-total-price-container .lbtu-price-current div');
    const addToCartBtn = document.querySelector('.lbtu-add-to-cart-button');

    if (priceDiv && addToCartBtn && priceDiv.innerHTML.trim() !== "") {
      const updateButton = () => {
        addToCartBtn.innerHTML = priceDiv.innerHTML + " - Add to cart";
        console.log('Price updated in Add to Cart button');
      };

      updateButton(); // initial set

      // Watch for changes in the priceDiv
      const observer = new MutationObserver(() => {
        if (priceDiv.innerHTML.trim() !== "") {
          updateButton();
        }
      });

      observer.observe(priceDiv, { childList: true, subtree: true, characterData: true });

      clearInterval(interval);
    } else {
      elapsed += intervalTime;
      if (elapsed >= maxWaitTime) {
        console.log('Required elements not found or price content is empty within 5 seconds');
        clearInterval(interval);
      }
    }
  }, intervalTime);
});
